<template lang="html">
  <v-text-field
    :value="value"
    :prepend-icon="icon"
    :label="label"
    :type="type"
    :disabled="disabled"
    :rules="rules"
    class="busie-input"
    @input="$emit(&quot;input&quot;, $event)"/>
</template>

<script>
export default {
  props: {
    value: String | Number,
    icon: String,
    label: String,
    type: {
      required: false,
      default: 'text'
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    }
  }
}
</script>

<style lang="css" scoped>
</style>
